import { render, staticRenderFns } from "./VueFooter.vue?vue&type=template&id=45001320&"
import script from "./VueFooter.vue?vue&type=script&lang=js&"
export * from "./VueFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports